<ng-container
*ngIf="operationTemplateRef_hd"
[ngTemplateOutlet]="operationTemplateRef_hd"
[ngTemplateOutletContext]="{$implicit:topData}"
>
</ng-container>
<div class="d-flex  align-items-center mb-2">
    <div class="dropdown" *ngIf="filter_title == true" style="margin-right: 0.5%;margin-top: 0.5%;">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            顯示的欄位
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" [id]="'checkboxall'" [(ngModel)]="search_all_val" (change)="search_all()">
                <label class="form-check-label" [for]="'checkboxall'" (click)="$event.stopPropagation()">
                    全選
                </label>
            </div>
            <div class="form-check" *ngFor="let option of options; let i = index">
                <input class="form-check-input" type="checkbox" [id]="'checkbox' + i" [value]="option.title" [(ngModel)]="selectedOptions[option.title]"  (change)="search_option()">
                <label class="form-check-label" [for]="'checkbox' + i" (click)="$event.stopPropagation()">
                    {{ option.title }}
                </label>
            </div>
        </div>
    </div>

    <div class="export" style="margin-top: 0.5%;margin-right: 0.5%;" *ngIf="urltoken?.length > 0">
        <a  href="{{urltoken}}" target="_blank"  class="btn btn-info">匯出</a>
    </div>
    <div class="export" style="margin-top: 0.5%;" *ngIf="urltokencsv?.length > 0">
        <a  href="{{urltokencsv}}" target="_blank"  class="btn btn-info">匯出csv</a>
    </div>
</div>


<!-- loadmore -->
<table  id="lists-chats"  class="lists-chats scrollbar" *ngIf=" loadmore == 1"   (scroll)="onScroll()">

    <div *ngIf="pageobj?.total_count > 0" style="margin-bottom: 10px">
        <span>
            第<input type="number" id="numericInputs" [(ngModel)]="input_tmp_page" (change)="inputpage()" name="numericInputs" min="0" max="100">筆
        </span>
        <span>
            第 {{page_start}} - {{page_end}} 筆   總筆數:{{pageobj.total_count}}
        </span>
    </div>
    <thead [style]="' position: sticky; top: 0;'">
        <tr *ngIf="titleTableName.length > 0">
            <th>
                {{titleTableName[0].name}}
            </th>
            <th *ngFor="let item of titleTableContent; let i = index" [attr.colSpan]="item.colspan" [style.background-color]="colorArray[i]" [style.color]="'white'">
                {{item.name}}
            </th>
        </tr>
        <tr *ngIf="titleTableName.length > 0 && sumopt == true">
            <th>
                合計
            </th>
            <th *ngFor="let item of tcontentTit; let i = index" [attr.colSpan]="'1'">
                {{aSum[item.content]| dynamicFormat:'number'}}
            </th>
        </tr>
        <tr class="totalclass">
            <th *ngIf="topData.length > 0">
                <input type="checkbox" (change)="CheckboxChange()" />
            </th>
            <th *ngFor="let detal of title let i = index"
                (click)="sort_fnx(content[i].content, sort_obj.sort, detal.sort)"
                [style]="detal.css"
                [ngClass]="{
                    'sorting': detal.sort,
                    'sorting_asc': sort_obj.column === content[i].content && sort_obj.sort === '0',
                    'sorting_desc': sort_obj.column === content[i].content && sort_obj.sort !== '0'
                }">
                <ng-container *ngIf="detal.sort; else notSortable">
                    <span>
                        {{ detal.title }}
                    </span>
                </ng-container>
                <ng-template #notSortable>
                    {{ detal.title }}
                </ng-template>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let dataitem of data let i = index">
            <td *ngIf="topData.length > 0">
                <input type="checkbox" [(ngModel)]="topData[i].selected" />
            </td>
            <td *ngFor="let item of content"   [style]="item.css" >

                <div *ngIf="item.type == 3">
                    <ng-container
                        *ngIf="operationTemplateRef_dk"
                        [ngTemplateOutlet]="operationTemplateRef_dk"
                        [ngTemplateOutletContext]="{$implicit:{idx: i, key:item.content, val:dataitem}}"
                    >
                    </ng-container>
                </div>

                <div *ngIf="item.type == 1">
                    <div class="picborder" *ngIf="bounty_id.includes(dataitem.id)">
                        <p>wanted</p>
                        <img  [src]="dataitem[item.content]" alt="" style="width: 30px;">
                        <div *ngFor="let bountyitem of bounty_arr">
                            <p *ngIf="bountyitem.user_id == dataitem.id">NT {{bountyitem.diamond}}</p>
                        </div>
                    </div>
                    <div *ngIf="!bounty_id.includes(dataitem.id)">
                        <img  [src]="dataitem[item.content]" alt="" style="width: 30px;">
                    </div>
                </div>

                <div *ngIf="item.type == 2">
                    {{dataitem | json}}
                </div>

                <div *ngIf="item.type != 1 && item.type != 2 && item.type != 3 && item?.model != 1 && item?.model != 2">
                    {{ item.replaceArr ? item.replaceArr[dataitem[item.content]] : dataitem[item.content] | dynamicFormat:item?.format }}
                </div>

                <div *ngIf="item?.model == 1">
                    <a href="javascript:void(0)" (click)="handleClick(dataitem[item.handlelinkvalue])">{{ dataitem[item.content] | dynamicFormat:item?.format }}</a>
                </div>
                <div *ngIf="item?.model == 2" [innerHTML]="custom" (click)="handleClick(dataitem)"></div>
            </td>
        </tr>
    </tbody>
</table>


<!-- pc正常版 -->
<table class="lists-chat" *ngIf="(isMobile == false || isMobile && type == 1) && loadmore != 1" >

    <div *ngIf="pageobj?.total_count > 0" style="margin-bottom: 10px">
        <span>
            第<input type="number" id="numericInputs" [(ngModel)]="input_tmp_page" (change)="inputpage()" name="numericInputs" min="0" max="100">筆
        </span>
        <span>
            第 {{page_start}} - {{page_end}} 筆   總筆數:{{pageobj.total_count}}
        </span>
    </div>
    <thead>
        <tr *ngIf="titleTableName.length > 0">
            <th>
                {{titleTableName[0].name}}
            </th>
            <th *ngFor="let item of titleTableContent; let i = index" [attr.colSpan]="item.colspan" [style.background-color]="colorArray[i]" [style.color]="'white'">
                {{item.name}}
            </th>
        </tr>
        <tr *ngIf="titleTableName.length > 0 && sumopt == true">
            <th>
                合計
            </th>
            <th *ngFor="let item of tcontentTit; let i = index" [attr.colSpan]="'1'">
                {{aSum[item.content]| dynamicFormat:'number'}}
            </th>
        </tr>
        <tr>
            <th *ngIf="topData.length > 0">
                <input type="checkbox" (change)="CheckboxChange()" />
            </th>
            <th *ngFor="let detal of title let i = index"
            (click)="sort_fnx(content[i].content, sort_obj.sort, detal.sort)"
            [style]="detal.css"
                [ngClass]="{
                    'sorting': detal.sort,
                    'sorting_asc': sort_obj.column === content[i].content && sort_obj.sort === '0',
                    'sorting_desc': sort_obj.column === content[i].content && sort_obj.sort !== '0'
                }">
                <ng-container *ngIf="detal.sort; else notSortable">
                    <span>
                        {{ detal.title }}
                    </span>
                </ng-container>
                <ng-template #notSortable>
                    {{ detal.title }}
                </ng-template>
            </th>
        </tr>
    </thead>
    <!-- type 在這裡選擇。 -->
    <tbody>
        <!-- 無資料時顯示 -->
        <tr *ngIf="data.length === 0">
            <td [attr.colspan]="content.length + (topData.length > 0 ? 1 : 0)" class="text-center text-muted">
                無資料
            </td>
        </tr>

        <!-- 使用 ng-container 包裹 *ngIf 來避免 *ngFor 衝突 -->
        <ng-container *ngIf="data?.length > 0">
            <tr *ngFor="let dataitem of data let i = index" [ngStyle]="{'background-color': highlightCondition ? (i % 2 === 0 ? highlightColor : 'white') : 'white'}">

                <td *ngIf="topData.length > 0">
                    <input type="checkbox" [(ngModel)]="topData[i].selected" />
                </td>

                <td *ngFor="let item of content"   [style]="item.css" >
                    <!-- {{item|json}} -->
                    <div *ngIf="item.type == 3">
                        <ng-container
                            *ngIf="operationTemplateRef_dk"
                            [ngTemplateOutlet]="operationTemplateRef_dk"
                            [ngTemplateOutletContext]="{$implicit:{idx: i, key:item.content,val:dataitem}}"
                        >
                        </ng-container>
                    </div>

                    <div *ngIf="item.type == 1">
                        <div class="picborder" *ngIf="bounty_id.includes(dataitem.id)">
                            <p>wanted</p>
                            <img  [src]="dataitem[item.content]" alt="" style="width: 30px;">
                            <div *ngFor="let bountyitem of bounty_arr">
                                <p *ngIf="bountyitem.user_id == dataitem.id">NT {{bountyitem.diamond}}</p>
                            </div>
                        </div>
                        <div *ngIf="!bounty_id.includes(dataitem.id)">
                            <img  [src]="dataitem[item.content]" alt="" style="width: 30px;">
                        </div>
                    </div>
                    <div *ngIf="item.type == 2">
                        <!-- 盜圖警告包裝 -->
                        <div  *ngIf="isCopyrightViolation(dataitem.user_id)">
                            <!-- 原始內容 -->
                            <div class="post-content" [class.blurred]="isCopyrightViolation(dataitem.user_id)">
                                ⚠️
                                <app-userandactive
                                    [post]="dataitem"
                                    [active]="item.active ? item.active : undefined">
                                </app-userandactive>
                            </div>
                        </div>

                        <div *ngIf="!isCopyrightViolation(dataitem.user_id)">
                            <app-userandactive
                                [post]="dataitem"
                                [active]="item.active ? item.active : undefined">
                            </app-userandactive>
                        </div>
                    </div>

                    <div *ngIf="item.type != 1 && item.type != 2 && item.type != 3 && item?.model != 1 && item?.model != 2">
                        {{ item.replaceArr ? item.replaceArr[dataitem[item.content]] : dataitem[item.content] | dynamicFormat:item?.format }}
                    </div>

                    <div *ngIf="item?.model == 1">
                        <a href="javascript:void(0)" (click)="handleClick(dataitem[item.handlelinkvalue])">{{ dataitem[item.content] | dynamicFormat:item?.format }}</a>
                    </div>
                    <div *ngIf="item?.model == 2" [innerHTML]="custom" (click)="handleClick(dataitem)"></div>
                </td>
            </tr>
        </ng-container>
    </tbody>
</table>

<!-- 手機板要注意是否有記得在組件上傳入[type] = "2" -->
<!-- 手機板 -->
<div *ngIf="isMobile && type == 2 && loadmore != 1">

    <div *ngIf="shouldShowMobileSortPanel()" class="mobile-sort-panel">
        <div class="sort-type">
            <select [(ngModel)]="selectedSortType" (change)="cardsort_fn(selectedSortType, selectedSortOrder)">
                <option default disabled value="-1">請選擇排序名稱</option>
                <ng-container *ngFor="let detal of title">
                    <option *ngIf="detal.sort" [value]="detal.sort">{{ detal.title }}</option>
                </ng-container>
            </select>
        </div>
        <div class="sort-order">
            <select [(ngModel)]="selectedSortOrder" (change)="cardsort_fn(selectedSortType, selectedSortOrder)">
                <option default disabled value="-1">請選擇排序順序</option>
                <option value="0">由高到低</option>
                <option value="1">由低到高</option>
            </select>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body" *ngIf="data.length > 0">
                        <div *ngFor="let item of data let i = index" class="row mb-3">
                            <div class="col-6">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="d-flex align-items-center" *ngFor="let titledetail of title let is = index">
                                            <h5 class="card-title mb-2">{{titledetail.title}}:</h5>

                                            <div *ngIf="content[is].type == 1">
                                                <img  [src]="item[content[is].content]" alt="" style="width: 30px;margin-left: 10px;">
                                            </div>
                                            <div *ngIf="content[is].type == 2" style="margin-left: 10px;">
                                                <app-userandactive  [post]="item" [active]="item.active ? item.active : undefined"></app-userandactive>
                                            </div>
                                            <div *ngIf="content[is].type == 3" style="margin-left: 10px;">
                                                <ng-container
                                                    *ngIf="operationTemplateRef_dk"
                                                    [ngTemplateOutlet]="operationTemplateRef_dk"
                                                    [ngTemplateOutletContext]="{$implicit:{idx: i, key:content[is].content,val:item}}"
                                                >
                                                </ng-container>

                                            </div>
                                            <div *ngIf="content[is].type != 1 && content[is].type != 2 && content[is].type != 3  && content[is]?.model != 1">
                                                <p class="card-text mb-2 ml-3">{{content[is].replaceArr ? content[is].replaceArr[item[content[is].content]]: item[content[is].content]| dynamicFormat:content[is].format}}</p>
                                            </div>
                                            <div *ngIf="content[is]?.model == 1">
                                                <a href="javascript:void(0)" (click)="handleClick(item.name)">{{item[content[is].content] | dynamicFormat:content[is].format}}</a>
                                            </div>
                                            <div *ngIf="content[is]?.model == 2" [innerHTML]="custom" (click)="handleClick(item)"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 你可以根據需要添加更多的列 -->
                        </div>
                    </div>
                    <div *ngIf="!data.length || data.length == 0" class="no-data text-center mt-4">無資料</div>
                </div>
            </div>
        </div>
        <a *ngIf="showbacktop" (click)="go_top()" id="go_top" onclick="return false" class="back-to-top"> <i style="font-size: 1.73em;" class="fas fa-arrow-circle-up"></i> </a>
    </div>
</div>
